module.exports = __webpack_public_path__ + "img/c77.11625bf5.png";